module.exports = __webpack_public_path__ + "static/img/yunyan.22167b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/yunyan.png
// module id = 7YfK
// module chunks = 44